/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Consents_NoneInputs */

const cs_clients_consents_none = /** @type {(inputs: Clients_Consents_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádný souhlas není zaznamenán`)
};

const en_clients_consents_none = /** @type {(inputs: Clients_Consents_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No consent recorded`)
};

/**
* | output |
* | --- |
* | "No consent recorded" |
*
* @param {Clients_Consents_NoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_consents_none = /** @type {((inputs?: Clients_Consents_NoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Consents_NoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_consents_none(inputs)
	return cs_clients_consents_none(inputs)
});